import { useCallback } from "react";
import { useMutation } from "react-query";

import type { LoginAuthenticationStrategies, OtpChannel } from "@jti/fe-common";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { CasProfileApi } from "../../../services";

import type { UseSendLoginOTCReturnType } from "./types";

export const useSendLoginOTC = (): UseSendLoginOTCReturnType => {
  const callSendLoginOTC = useMutation(
    MUTATION_KEYS.sendLoginOTC,
    ({
      phone,
      otpChannel,
      otpTemplate,
      strategy,
    }: {
      phone: string;
      otpChannel: OtpChannel;
      otpTemplate?: string;
      strategy?: LoginAuthenticationStrategies;
    }) => CasProfileApi.init().sendLoginOTC(phone, otpChannel, otpTemplate, strategy)
  );

  const sendLoginOTC = useCallback(
    async (phone: string, otpChannel: OtpChannel, otpTemplate?: string, strategy?: LoginAuthenticationStrategies) =>
      await callSendLoginOTC.mutateAsync({ phone, otpChannel, otpTemplate, strategy }),
    [callSendLoginOTC]
  );

  return { sendLoginOTC };
};
